import { just, Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import LoadingIndicator from '../LoadingIndicator';
import { LoadingAnimationType } from '../LoadingIndicator/Types';
import clsx from 'clsx';

import { T, TPlainTextKey } from '../../Translations';

const LoaderMessage: React.FC<{ text: Maybe<TPlainTextKey> }> = ({ text }) =>
  text.map((t) => <T kind={t} />).getOrElseValue(<></>);

interface Props {
  type?: LoadingAnimationType;
  color?: string;
  text?: Maybe<TPlainTextKey>;
  height?: number;
  width?: number;
  delay?: number;
  className?: string;
}

const Loader: React.FC<Props> = ({
  type = 'bubbles',
  color = 'black',
  text = just('loading content'),
  height = 100,
  width = 100,
  delay = 1000,
  className = 'h-screen',
}) => (
  <div className={clsx('flex items-center justify-center', className)}>
    <div className="flex flex-col items-center text-center text-xs">
      <LoadingIndicator
        className="mx-0 my-auto"
        type={type}
        color={color}
        height={height}
        width={width}
        delay={delay}
      />
      <LoaderMessage text={text} />
    </div>
  </div>
);

export default observer(Loader);
